export default "__VITE_ASSET__D$0$9Wwd__"